import { getAuthorizationConfig } from '../../src/config';
import { getAPI } from '../config';
let apitoken = null;
export const getApiToken = () => apitoken;
export const setApiToken = (v) => (apitoken = v);
const getAuthHeader = async () => {
    let token = null;
    if (apitoken) {
        const config = getAuthorizationConfig();
        token = await apitoken(config.apiscope);
    }
    return {
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
        },
    };
};
const handleResponse = (res) => {
    if (res.status === 401) {
        window.location.href = `/`;
        return;
    }
    if (res.status === 500)
        return null;
    return res !== null ? res.json() : [];
};
// const getHeaders = () => {
//   const localContext = window.localStorage.getItem('context') || ''
//   const localToken = window.localStorage.getItem('AccessToken')
//   return {
//     Authorization: `Bearer ${localToken}`,
//     context: localContext }
// }
const service = {
    get: async (url, options) => {
        const authheader = await getAuthHeader();
        const payload = { ...options, ...authheader /*credentials: 'include'*/ };
        return fetch(getAPI() + url, payload).then(handleResponse);
    },
    post: async (url, body, options = {}) => {
        const authheader = await getAuthHeader();
        return fetch(getAPI() + url, {
            ...options,
            ...authheader,
            /*credentials: 'include',*/ method: 'POST',
            body: JSON.stringify(body),
        }).then(handleResponse);
    },
    put: async (url, body, options = {}) => {
        const authheader = await getAuthHeader();
        return fetch(getAPI() + url, {
            ...options,
            ...authheader,
            /*credentials: 'include',*/ method: 'PUT',
            body: JSON.stringify(body),
        }).then(handleResponse);
    },
    delete: async (url, options = {}) => {
        const authheader = await getAuthHeader();
        return fetch(getAPI() + url, {
            ...options,
            ...authheader,
            /*credentials: 'include',*/ method: 'DELETE',
        }).then(handleResponse);
    },
};
export async function getRemotes() {
    return service.get(`/remotes`, {});
}
export async function createDatasetFile(appcontext, data) {
    return service.post(`/FileService?appcontext=${appcontext}`, data, {});
}
export async function saveDataset(appcontext, data) {
    return service.post(`/ModelService?appcontext=${appcontext}`, data, {});
}
export async function getDataset(appcontext, id) {
    return service.get(`/ModelService/datasets/${id}?appcontext=${appcontext}`, {});
}
export async function queryDatasetProperties(appcontext, propertyName) {
    return service.get(`/ModelService/properties?name=${propertyName}&appcontext=${appcontext}`, {});
}
export async function deleteDataset(appcontext, id) {
    return service.delete(`/ModelService/${id}?appcontext=${appcontext}`, {});
}
export async function getApplicationConfig() {
    return service.get(`/ConfigService`, {});
}
export async function queryEditorSpecification(appcontext, scenarioId) {
    return service.get(`/EditorService/scenarios/${scenarioId}/specification?appcontext=${appcontext}`, {});
}
export async function queryEditorGeodata(appcontext) {
    return service.get(`/EditorService/scenarios/geodata?appcontext=${appcontext}`, {});
}
export async function queryEditorDataset(appcontext, scenarioId, datasetName, format = 'json') {
    return service.get(`/EditorService/scenarios/${scenarioId}/datasets/${datasetName}/${format}?appcontext=${appcontext}`, {});
}
// export async function queryEditorMapStyle(appcontext: string, scenarioId: string, fileName: string): Promise<any> {
//   return service.get(`/EditorService/scenarios/${scenarioId}/${fileName}?appcontext=${appcontext}`, {})
// }
// export async function saveDatasets(appcontext: string, scenarioId: string, datasets: any): Promise<any> {
//   return service.post(`/EditorService/scenarios/${scenarioId}/datasets?appcontext=${appcontext}`, datasets, {})
// }
// export async function queryDatasets(appcontext: string, property: IProperty): Promise<any> {
//   return service.get(`/ModelService?name=${property.name}&value=${property.value}&appcontext=${appcontext}`, {})
// }
// export async function listDatasets(appcontext: string, path: string, type: string): Promise<any> {
//   return service.get(`/EditorService/datasets/${path}/${type}?appcontext=${appcontext}`, {})
// }
// export async function getDatasetContent(appcontext: string, dataset: any): Promise<any> {
//   const mappedDirectory = dataset.directory.replace(/\//g, ':')
//   const d = encodeURIComponent(mappedDirectory)
//   const f = encodeURIComponent(dataset.filename)
//   return service.get(`/EditorService/animation/${d}?appcontext=${appcontext}`, {})
// }
// Gets animation timeperiod. Segment refers to time period. Directory refers
// to animation directory
// export async function getDatasetSegmentContent(appcontext: string, dataset: any, timeperiodStr: string): Promise<any> {
//   const mappedDirectory = dataset.directory.replace(/\//g, ':')
//   const directory = encodeURIComponent(mappedDirectory)
//   // console.log(`/EditorService/animation/${directory}/${timeperiodStr}`)
//   return service.get(`/EditorService/animation/${directory}/${timeperiodStr}?appcontext=${appcontext}`, {})
// }
